<template>
  <b-card-code title="Search Tree">
    <b-input-group class="mb-1">
      <b-input-group-prepend is-text>
        <feather-icon icon="SearchIcon"/>
      </b-input-group-prepend>
      <b-form-input
          v-model.lazy="searchWord"
          placeholder="Search..."
          @input="search"
      />
    </b-input-group>
    <v-tree
        ref="tree"
        @node-select="onSelect"
        :can-delete-root="false"
        :data="treeData"
        :draggable="true"
        :tpl="tpl"
        :radio="true"
        :halfcheck="true"
        :multiple="false"
    />
  </b-card-code>
</template>

<script>
import {VTree} from 'vue-tree-halower'
import {TreeConfig, PropertyConfig, FieldType, Filter, Operator} from '../../common/index.d.ts'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BFormInput, BInputGroupPrepend, BInputGroup,
} from 'bootstrap-vue'

import store from '@/store'
import {ref} from "@vue/composition-api";

export default {
  components: {
    VTree,
    BCardCode,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
  },

  model: {
    event: 'update:is-add-new-menu-active',
  },

  props: {
    treeConfig: {
      type: TreeConfig,
      required: true,
    },
  },

  setup(props, {emit}) {
    let treeData = ref([{
      title: 'node1',
      expanded: true
    }]);

    console.log(treeData)
    let config = props.treeConfig;
    let searchWord = ref("")


    store.dispatch(config.rootAction, config.actionData)
        .then(response => {
          let menus = response.data.data;
          treeData.value = menus;
          console.log("tree data ==")
        })
        .catch(error => {
          console.log(error);
        });
    let onCreateEdit = (node) => {
      emit('update:is-add-new-menu-active', node);

    };

    console.log(config);


    let res = {
      "treeData": treeData,
      "searchWord": searchWord,
      "onCreateEdit": onCreateEdit,
    };
    return res;
  },

  methods: {
    search() {
      // this.$refs.tree.searchNodes(this.searchWord)
    },
    tpl(...args) {
      const {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      return <span>
        <span class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
          this.$refs.tree.nodeSelected(node)
          this.asyncLoad(node)
        }}></span>


        <button class="btn-edit text-warning border-0 cursor-pointer mr-1"
                onClick={() => this.onCreateEdit(node)}>add</button>

        <button class="btn-delete text-danger border-0 cursor-pointer"
                onClick={() => this.$refs.tree.delNode(node, parent, index)}>delete</button>
      </span>
    },
    loadChildren() {
      let selected = this.$refs.tree.getSelectedNodes();
      this.asyncLoad(selected)
    },

    onSelect(node) {
      console.log(node);
    },
    async asyncLoad(node) {
      const {checked = false} = node
      this.$set(node, 'loading', true)
      store.dispatch('app-cms/getMenuChildrenById', {id: node.id})
          .then(response => {
            let menus = response.data.data;
            if (menus.length > 0) {
              this.$set(node, "children", []);
              this.$refs.tree.addNodes(node, menus)
            }

            this.$set(node, 'loading', false)
            if (checked) {
              this.$refs.tree.childCheckedHandle(node, checked)
            }
          })
          .catch(error => {
            console.log(error);
          })
    },
  },
}
</script>
